import * as React from "react";

export const AiSparklesSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="41.706" height="41.338" viewBox="0 0 41.706 41.338">
        <g id="Group_8" data-name="Group 8" transform="translate(0)">
            <path
                id="Icon_weather-stars" data-name="Icon weather-stars"
                d="M6.444,30.953a5.1,5.1,0,0,0,3.573-1.624,5.089,5.089,0,0,0,1.472-3.638,5.254,5.254,0,0,0,5.024,5.262,5.254,5.254,0,0,0-5.024,5.262,5,5,0,0,0-1.472-3.638A5.1,5.1,0,0,0,6.444,30.953Zm5.045-15.591a9.952,9.952,0,0,0,6.951-3.183,9.912,9.912,0,0,0,2.858-7.1,9.912,9.912,0,0,0,2.858,7.1,10.05,10.05,0,0,0,6.973,3.183A10.036,10.036,0,0,0,26.171,16.9,10.406,10.406,0,0,0,22.6,20.645a10.183,10.183,0,0,0-1.3,5.045,9.962,9.962,0,0,0-2.858-7.124A9.887,9.887,0,0,0,11.489,15.362Zm7.189,23.322a7.735,7.735,0,0,0,7.384-7.731,7.737,7.737,0,0,0,7.362,7.731,7.737,7.737,0,0,0-7.362,7.731,7.457,7.457,0,0,0-2.144-5.349A7.586,7.586,0,0,0,18.679,38.684ZM33.425,28.419a7.7,7.7,0,0,0,7.341-7.752A7.735,7.735,0,0,0,48.15,28.4a7.735,7.735,0,0,0-7.384,7.731,7.659,7.659,0,0,0-7.341-7.709Z"
                transform="translate(-6.444 -5.076)"
                fill="currentColor"
            />
        </g>
    </svg>
);
